import apiClient from '../client'
import type {
  EntityAuditVerificationResponse,
  TableAuditVerificationResponse,
  AuditRecord,
  SeedAuditBaselineResponse,
  AuditTableSummary,
} from '../models/response'

const BASE_PATH = '/audit'

export interface VerifyTableRequest {
  verificationType: string
  dateFrom?: string
  dateTo?: string
}

export const auditService = {
  async getSummary(): Promise<AuditTableSummary[]> {
    return apiClient.get<AuditTableSummary[]>(`${BASE_PATH}/summary`)
  },

  async getAuditableEntities(): Promise<string[]> {
    return apiClient.get<string[]>(`${BASE_PATH}/entities`)
  },

  async verifyEntity(entityName: string, entityId: string): Promise<EntityAuditVerificationResponse> {
    return apiClient.get<EntityAuditVerificationResponse>(`${BASE_PATH}/verify/${entityName}/${entityId}`)
  },

  async verifyTable(entityName: string, request: VerifyTableRequest): Promise<TableAuditVerificationResponse> {
    return apiClient.post<TableAuditVerificationResponse>(`${BASE_PATH}/verify/${entityName}`, request)
  },

  async getEntityAuditHistory(entityName: string, entityId: string): Promise<AuditRecord[]> {
    return apiClient.get<AuditRecord[]>(`${BASE_PATH}/history/${entityName}/${entityId}`)
  },

  async seedBaseline(): Promise<SeedAuditBaselineResponse> {
    return apiClient.post<SeedAuditBaselineResponse>(`${BASE_PATH}/seed-baseline`, {})
  },
}

export default auditService
